module.exports = __webpack_public_path__ + "static/media/GoogleWallet1.a67b5458.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/GoogleWallet1.png
// module id = 6163
// module chunks = 1